import $axios from "../../../api/accessories";
import { $api } from "../../../api/api";
import { fileToDataUrl } from "../../../helper/imageConverter";

export class HeaderProvide {
  static async getHeaderProductCategories(lang: string = "az") {
    try {
      const response = await $axios.get($api("get_header_categories"), {
        headers: { "Accept-Language": lang },
        params: { lang },
      });
      return response;
    } catch (error) {
      console.error("API request error:", error);
      throw error;
    }
  }
  static async getOrderCategory(lang: string = "az") {
    try {
      const response = await $axios.get($api("get_order_category"), {
        headers: { "Accept-Language": lang },
        params: { lang },
      });
      return response;
    } catch (error) {
      console.error("API request error:", error);
      throw error;
    }
  }
  static async getHeaderServices() {
    // try {
    //   const response = await $axios.get($api("get_header_services"));
    //   return response;
    // } catch (error) {
    //   console.error("API request error:", error);
    //   throw error;
    // }
    return { data: { data: [] } };
  }
  static async getSearchProducts(
    searchKeyword: string,
    channel: string = "1688",
    page: number = 1,
    perPage: number = 24
  ) {
    try {
      const response = await $axios.get("partner/search/products", {
        params: {
          search: searchKeyword,
          channel: channel || "1688",
          page: page || 1,
          per_page: perPage || 24,
        },
      });
      return response;
    } catch (error) {
      console.log("Axtarışda nəticə tapılmadı:", error);
      return { data: { data: [], products: [] } };
    }
  }

  static searchProductsByImage = async (
    file: File | Blob | string,
    channel: string = "1688",
    page: number = 1,
    perPage: number = 24,
    extraParams?: Record<string, any>
  ) => {
    if (!file) {
      return { data: { data: [], products: [] } };
    }

    try {
      const base64Image =
        typeof file === "string" ? file : await fileToDataUrl(file);

      if (!base64Image) {
        throw new Error("Görüntü base64 formatına çevrilə bilmədi");
      }

      const payload: Record<string, any> = {
        image: base64Image,
        channel: channel || "1688",
        page: page || 1,
        per_page: perPage || 24,
        ...extraParams,
      };

      const response = await $axios.post($api("search_by_image"), payload);
      return response;
    } catch (error) {
      console.error("Şəkillə axtarış xətası:", error);
      throw error;
    }
  };
  static async getFilterItems(id: number) {
    try {
      const response = await $axios.get($api("filter_items_id", { id }));
      return response;
    } catch (error) {
      console.log("search error", error);
      throw error;
    }
  }

  static async getFilterData(payload: any) {
    try {
      const response = await $axios.post($api("filter_data"), payload);
      return response;
    } catch (error) {
      console.log("search error", error);
      throw error;
    }
  }

  static async getPartnerProducts(params: { category_id?: number | string; page?: number; per_page?: number; [key: string]: any }) {
    try {
      const resolvedParams = {
        per_page: 24,
        ...params,
      };
      const response = await $axios.get($api("partner_products", resolvedParams));
      return response;
    } catch (error) {
      console.log("partner products error", error);
      throw error;
    }
  }
  static async getLanguages() {
    try {
      const response = await $axios.get($api("get_languages"), {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,  
        },
      });
      return response;
    } catch (error) {
      console.error("API request error:", error);
      throw error;
    }
  }

}
